import React from 'react';
import clsx from 'clsx';

export const DescriptionSelector = React.forwardRef<
  HTMLButtonElement,
  {
    children: React.ReactNode;
    selected: boolean;
  } & React.ComponentPropsWithoutRef<'button'>
>(({ children, selected = false, className, ...props }, forwardedRef) => {
  return (
    <button
      data-state={!!selected ? 'active' : 'inactive'}
      ref={forwardedRef}
      {...props}
      className={clsx(
        'data-[state=active]:ring-[3px] data-[state=inactive]:ring-1 data-[state=active]:ring-base900 data-[state=inactive]:ring-base300',
        'data-[state=active]:bg-base100 data-[state=inactive]:bg-white ',
        'overflow-hidden whitespace-nowrap rounded-[6px] px-2 py-4 font-title text-title-s font-medium capitalize text-base900 hover:shadow-tertiary',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-base100 disabled:opacity-30',
        className,
      )}
    >
      {children}
    </button>
  );
});

DescriptionSelector.displayName = 'DescriptionSelector';
